export default {
  auditEntries: (state) => state.auditEntries,
  viewingAudit: (state) => state.viewingAudit,
  loading: (state) => state.loading,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
